import ApiConstants from '../constants/ApiConstants';
import http from "../http";
import { COLUMN_CODE, TableManger, TABLES } from '../managers/TableManger';

class KanbanService {
    static fetchStageMetaData(requestBody = {}, params = {}) {
        return http.post(ApiConstants.URL.TABLE.STAGE_META, requestBody, { params: {...params, _allowRetry: true } });
      }
    
      static fetchCandidateByStages(params: any = {}, data: any) {
        params = {
          pageNo: 1,
          pageSize: 20,
          colIdsToFetchRef: TableManger.getColumnId(
            TABLES.CANDIDATE,
            COLUMN_CODE.CANDIDATE.JOB_PIPELINE_ID
          ),
          _allowRetry: true,
          ...params,
        };
    let url = `${ApiConstants.URL.TABLE.CANDIDATE_RECORD_BY_PAGE}?pageNo=1&pageSize=${params.params.pageSize}&colIdsToFetchRef=${params.colIdsToFetchRef}&_allowRetry=true&pipelineId=${params.params.pipelineId}&q=${params.params.q ? params.params.q :""}`
        return http
          .post(`${url}`, data)
          .then(
            (response) => {
              response.data = response.data.map((record) => {
                return {
                  ...record,
                  cells: {
                    ...record.cells,
                    createdBy: record.createdBy,
                    id: record._id,
                  },
                };
              });
              return Promise.resolve(response);
            },
            (error) => {
              return Promise.reject(error);
            }
          )
          .catch((error) => {
            return Promise.reject(error);
          });
      }
}
export default KanbanService;